
import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const TimeComparison = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <div className="max-w-[1200px] mx-auto pb-6 px-6">
      <h2 
        className={`text-4xl md:text-5xl font-charter mb-12 text-center transition-all duration-1000 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        Work smarter, not harder.
      </h2>
      
      <div ref={ref} className="space-y-16 max-w-3xl mx-auto">
        {/* PlanniFi Bar */}
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-lg text-secondary">planniFi</span>
            <span className="text-lg font-medium">
              2 hours/week
            </span>
          </div>
          <div className="relative">
            <div className="h-12 bg-gradient-to-r from-[#D3E4FD] to-[#EDF4FE] rounded-full relative overflow-hidden">
              <div 
                className="absolute inset-0 bg-gradient-to-r from-[#27b5fc] to-[#7dcffd] rounded-full transition-all duration-1000 ease-in-out"
                style={{
                  width: isVisible ? '25%' : '0%'
                }}
              ></div>
            </div>
            {/* Floating line with arrow */}
            <div 
              className="absolute transition-all duration-1000 ease-in-out"
              style={{
                left: isVisible ? '25%' : '0%',
                right: '8px',
                bottom: '-12px',
                height: '3px',
                background: 'rgb(161 161 170)'
              }}
            >
              <div 
                className="absolute right-[-8px] w-0 h-0"
                style={{
                  borderTop: '6px solid transparent',
                  borderBottom: '6px solid transparent',
                  borderLeft: '8px solid rgb(161 161 170)',
                  transform: 'translateY(-50%)',
                  top: '50%'
                }}
              />
              <span 
                className="absolute text-secondary text-sm whitespace-nowrap"
                style={{
                  left: '50%',
                  transform: 'translateX(-50%)',
                  top: '12px'
                }}
              >
                Time allocated to other activities
              </span>
            </div>
          </div>
        </div>

        {/* Traditional Methods Bar */}
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-lg text-secondary">Traditional methods</span>
            <span className="text-lg font-medium">
              8+ hours/week
            </span>
          </div>
          <div className="h-12 bg-gradient-to-r from-gray-200 to-gray-100 rounded-full relative overflow-hidden">
            <div 
              className="absolute inset-0 bg-gradient-to-r from-gray-300 to-gray-200 rounded-full transition-all duration-1000 ease-in-out"
              style={{
                width: isVisible ? '100%' : '0%'
              }}
            ></div>
          </div>
        </div>
      </div>

      <p className="text-center text-secondary mt-8">
        Save up to 75% of your time on media planning and campaign management
      </p>
    </div>
  );
};

export default TimeComparison;
